import React from 'react';
import { observer, inject } from 'mobx-react';
import _ from 'lodash';

import ScrollIntoViewIfNeeded from 'react-scroll-into-view-if-needed';

const scrollIntoViewOptions = { behavior: 'instant', block: 'start' };

function TableOfContentsEntry({ AppState, path: selectedPath, children }) {
  let elementPath = AppState.selectedSectionItem;
  if (
    _.chain(AppState.selectedSectionItem)
      .last()
      .isInteger()
      .value()
  ) {
    elementPath = _.dropRight(AppState.selectedSectionItem);
  }
  return (
    <ScrollIntoViewIfNeeded
      options={scrollIntoViewOptions}
      active={_.isEqual(elementPath, selectedPath)}
    >
      {children}
    </ScrollIntoViewIfNeeded>
  );
}

export default inject('AppState')(observer(TableOfContentsEntry));



// WEBPACK FOOTER //
// ./src/app/components/BookElements/TableOfContentsEntry.js